import t from "./getWindowScroll.js";
import o from "./getWindow.js";
import { isHTMLElement as e } from "./instanceOf.js";
import l from "./getHTMLElementScroll.js";
function c(r) {
  return r === o(r) || !e(r) ? t(r) : l(r);
}
export {
  c as default
};
